import { create, getProtocolInitializer } from "./protocol.js";
/**
 * PlatformContext is an instance of the class that represents a specific Platform
 */
export class PlatformContext {
    network;
    config;
    constructor(network, config) {
        this.network = network;
        this.config = config;
    }
    /** provides access to the static attributes of the PlatformContext class */
    utils() {
        return this.constructor;
    }
    /** Create a new Protocol Client instance by protocol name using the RPC connection to determine the network */
    getProtocol(protocol, rpc) {
        return create(this.utils()._platform, protocol, rpc, this.config);
    }
    /** Get the underlying ProtocolInitializer to construct yourself */
    getProtocolInitializer(protocol) {
        return getProtocolInitializer(this.utils()._platform, protocol);
    }
    /** Look up transaction logs and parse out Wormhole messages */
    async parseWormholeMessages(chain, rpc, txid) {
        const wc = await this.getProtocol("WormholeCore", rpc);
        return wc.parseTransaction(txid);
    }
}
//# sourceMappingURL=platform.js.map